<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="selection-validate-modal modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('validation') }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                    </div>
                    <div v-if="!pending" class="modal-body fs-6 font-monospace">
                        <pre style="overflow: unset">
                            <p v-html="formattedString"></p>
                        </pre>
                    </div>
                    <div v-else class="modal-body">
                        <div class="spinner-border center-loading-element" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import AnalysisApi from "../../api/server/analysis";

export default {
    name: "selectionAnalyseModal",
    mounted() {
        this.validateData();
    },
    methods: {
        async validateData() {
            this.pending = true;
            this.validation = await AnalysisApi.validateSelection(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.pending = false;
        },
        close() {
            this.$emit("close");
        }
    },
    data() {
        return {
            validation: "",
            pending: true
        }
    },
    computed: {
        formattedString() {
            return this.validation.trim();//(/\s/g, '');
        }
    }
}
</script>